// eslint-disable-next-line @typescript-eslint/ban-types
export const keysOfObj = Object.keys as <T extends object>(
  obj: T
) => Array<keyof T>;

export const getShortDate = (value: string | number | Date): string => {
  return new Date(value)
    .toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    })
    .replace(/ /g, ' ');
};

export const getFullDateWithOrdinals = (
  value: string | number | Date
): string => {
  const date = new Date(value);
  const dayOfMonth = date.getDate();
  let suffix = 'th';
  if (dayOfMonth === 1 || dayOfMonth === 21 || dayOfMonth === 31) {
    suffix = 'st';
  } else if (dayOfMonth === 2 || dayOfMonth === 22) {
    suffix = 'nd';
  } else if (dayOfMonth === 3 || dayOfMonth === 23) {
    suffix = 'rd';
  }
  const longDate = date
    .toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    })
    .replace(/\b\d{1,2}\b/g, (day) => day + suffix);
  return longDate;
};

export const formatAMPM = (date: Date): string => {
  let hours = date.getHours();
  let minutes: number | string = date.getMinutes();
  const ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? '0' + minutes : minutes;
  const strTime = hours + ':' + minutes + ' ' + ampm;
  return strTime;
};

export const relDiff = (
  a: number | undefined,
  b: number | undefined
): number | null => {
  if (!!a && !!b) return ((b - a) * 100) / a;
  else return null;
};

/*
 * https://chrisbitting.com/2019/08/22/how-to-truncate-trim-text-by-sentence-in-javascript-not-word-or-character/
 */
export const truncateBySent = (
  str: string,
  sentCount = 3,
  moreText = ''
): string => {
  if (!str) return '';
  //match ".","!","?" - english ending sentence punctuation
  // eslint-disable-next-line no-useless-escape
  const sentences = str.match(/[^\.!\?]+[\.!\?]+/g);
  if (sentences) {
    if (sentences.length >= sentCount && sentences.length > sentCount) {
      //has enough sentences
      return sentences.slice(0, sentCount).join(' ') + moreText;
    }
  }
  //return full text if nothing else
  return str;
};

export const arrayColumn = (
  arr: Array<Array<number>>,
  n: number
): Array<number> => arr.map((x) => x[n] as number);

// Shorten a string to less than maxLen characters without truncating words.
const shorten = (str: string, maxLen: number, separator = ' '): string => {
  if (str.length <= maxLen) return str;
  return str.substr(0, str.lastIndexOf(separator, maxLen));
};

export const substringAndElipsis = (title: string, len = 50): string => {
  return title.length > len ? shorten(title, len) + '...' : title;
};

export const getRandomValueFromArray = (array: unknown[]): unknown => {
  return array[Math.floor(Math.random() * array.length)];
};

export const getIndianFormat = (value: unknown, isCurrency = false): string => {
  if (value === null || value === undefined) return '';
  const returnVal =
    typeof value === 'number' ? value.toLocaleString('en-IN') : value;

  return isCurrency
    ? `₹${returnVal}`
    : `${typeof returnVal === 'string' ? returnVal : ''}`;
};

const MMMYYYYDate = (date: string): string => {
  const splitDate = date.split('_');
  return `${((splitDate[0] as string).slice(0, 3) as string).toUpperCase()} ${
    splitDate[1]
  }`;
};

export const generateTableHeaders = (
  data: Array<unknown>,
  name: string
): { key: string; placeHolder: string }[] => {
  return Object.keys(data[0] as Record<string, unknown>)
    .filter((key) => key !== 'subRows')
    .map((item) => {
      return {
        key: item,
        placeHolder: item === name ? '' : MMMYYYYDate(item),
      };
    });
};

export const addQueryParamToLink = (
  link: string,
  key: string,
  value: string
): string => {
  if (!link) return '';

  const url = new URL(link);
  url.searchParams.append(key, value);
  return url.toString();
};
